import React from "react";
import { useSelector } from "react-redux";
import {
    getHistoryListItemProps,
    getTransactionLinkUrl,
} from "@qgiv/donation-form";
import { selectAllFormSettings } from "../../../../../redux/slices/formSettingsSlice";
import { selectConfig } from "../../../../../redux/slices/configSettingsSlice";
import RecurringSummaryHistoryListItem from "./RecurringSummaryHistoryListItem";

/**
 * @param {object} props
 * @param {Array} props.currentTransHistory
 * @param {string} props.dateLabel
 * @param {Function} props.handleClick
 * @param {number} props.index
 * @param {string} props.statusLabel
 * @param {string} props.transactionIdLabel
 * @returns {React.JSX.Element}
 */
const ConnectedRecurringSummaryHistoryListItem = ({
    currentTransHistory,
    dateLabel,
    handleClick,
    index,
    statusLabel,
    transactionIdLabel,
}) => {
    const {
        currency = {},
        template,
        type,
    } = useSelector(selectAllFormSettings);
    const { path = "" } = useSelector(selectConfig);
    const { receiptId = "" } = currentTransHistory;

    const transactionLinkUrl = getTransactionLinkUrl({
        path,
        receiptId,
        template,
        type,
    });

    const {
        displayErrorStyling,
        displayStatusIcon,
        displayTopMargin,
        displayTransactionIdLink,
        formattedTextAfterTransactionId,
        formattedTextBeforeTransactionId,
        formattedTransactionAmount,
        formattedTransactionDate,
        transactionId,
        translatedStatus,
    } = getHistoryListItemProps({
        currency,
        currentTransHistory,
        dateLabel,
        index,
        path,
        transactionIdLabel,
    });

    const historyItemProps = {
        displayErrorStyling,
        displayStatusIcon,
        displayTopMargin,
        displayTransactionIdLink,
        formattedTextBeforeTransactionId,
        formattedTextAfterTransactionId,
        formattedTransactionAmount,
        formattedTransactionDate,
        handleClick,
        statusLabel,
        transactionId,
        transactionLinkUrl,
        translatedStatus,
    };

    return <RecurringSummaryHistoryListItem {...historyItemProps} />;
};

export default ConnectedRecurringSummaryHistoryListItem;
